import { useEffect, useState } from "react";
import { faqs } from "@/mocks/mangaData";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import Guide from "./components/Guide";
import Rankings from "./components/Rankings";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import AboutContact from "./components/AboutContact";
import Footer from "./components/Footer";

export default function Home() {
  const [searchQuery, setSearchQuery] = useState("");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const faqLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero onSearch={setSearchQuery} />
        <Featured query={searchQuery} />
        <Categories />
        <Guide />
        <Rankings />
        <Testimonials />
        <Faq />
        <AboutContact />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-lg hover:bg-primary-600 transition-colors"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </div>
  );
}